export default "__VITE_ASSET__qsVmdpok__"